import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { notificationsActions } from '../../_actions/notifications.actions';
import { notificationConstants } from '../../_constants/notification.constants';
import { subscribe } from '../../_utils/syncSummary';

// Module-level pause flag so the dev seed helper can freeze polling
// while fake items are displayed. Toggled by window.__seedNotifications.
let paused = false;
export const setNotificationPollPaused = (value) => { paused = !!value; };

/**
 * The bell badge's unread count.
 *
 * Rides the app's one routine poll (/sync/summary via _utils/syncSummary):
 * paused while the tab is hidden, asked again the moment it comes back,
 * backing off from 30s to 2 min while nothing changes. The count comes in the
 * summary itself, so there is no separate /notification-v2/unread-count call;
 * against an older server (no /sync/summary) the summary falls back to the
 * old cadence and this asks /unread-count as before.
 *
 * - On `active=false`: this screen stops following it
 * - On unmount: unsubscribes, nothing leaks
 * - A failed poll leaves the badge as it was
 *
 * The full notification list is NOT polled — it's fetched only when the
 * user opens the bell panel (component layer triggers loadNotifications).
 */
export const useNotificationPoll = (active) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!active) return undefined;
    return subscribe({
      areas: ['notifications'],
      onUpdate: (data, event) => {
        if (paused || event.error) return;
        const n = data.notifications;
        if (n && typeof n.unread === 'number') {
          if (event.changed.includes('notifications')) dispatch({ type: notificationConstants.UNREAD_COUNT_SUCCESS, count: n.unread });
        } else if (n && n.legacy && event.changed.includes('notifications')) {
          // Older server: ask the old endpoint, at its old cadence.
          dispatch(notificationsActions.loadUnreadCount());
        }
      },
    });
  }, [active, dispatch]);

};
